import { API_BASE_URL } from './config/apiConfig';

/** Shipped fallback; the live address comes from useSupportEmail (Admin > Operations). */
export const DEFAULT_SUPPORT_EMAIL = 'support@wisefriend.org';

export const config = {
  API_URL: API_BASE_URL,
};
